export enum ScorerGrade {
  level0 = 0, // ungraded / referee
  level1 = 1,
  level2 = 2,
  level3 = 3,
  level4 = 4,
  level5 = 5,
}

export namespace ScorerGrade {
  export function all(): ScorerGrade[] {
    return [
      ScorerGrade.level0,
      ScorerGrade.level1,
      ScorerGrade.level2,
      ScorerGrade.level3,
      ScorerGrade.level4,
      ScorerGrade.level5,
    ];
  }

  export function parse(grade: string): ScorerGrade {
    if (!grade || grade.length === 0) return ScorerGrade.level0;
    const g = grade.toLowerCase();
    if (g.includes("1")) return ScorerGrade.level1;
    if (g.includes("2")) return ScorerGrade.level2;
    if (g.includes("3")) return ScorerGrade.level3;
    if (g.includes("4")) return ScorerGrade.level4;
    if (g.includes("5")) return ScorerGrade.level5;

    return ScorerGrade.level0;
  }

  export function toShortString(gr: ScorerGrade): string {
    switch (gr) {
      case ScorerGrade.level0:
        return "L0 / UG";
      case ScorerGrade.level1:
        return "L1";
      case ScorerGrade.level2:
        return "L2";
      case ScorerGrade.level3:
        return "L3";
      case ScorerGrade.level4:
        return "L4";
      case ScorerGrade.level5:
        return "L5";
      default:
        return "-";
    }
  }
}
